import { BaseFetch } from "../main-model"
export default class TrainingModel extends BaseFetch {
  getTrainingBy = (data) =>
    this.authFetch({
      url: "training/getTrainingBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getTrainingById = (data) =>
    this.authFetch({
      url: "training/getTrainingById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateTrainingById = (data) =>
    this.authFetch({
      url: "training/updateTrainingById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertTraining = (data) =>
    this.authFetch({
      url: "training/insertTraining",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteTrainingById = (data) =>
    this.authFetch({
      url: "training/deleteTrainingById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
